import { FindRelatedFilesRes } from '@dealstack/shared/lib/generated';

/**
 * Whether the "manage file associations" step has anything for the user to decide.
 *
 * there are two independent reasons to stop there — transactions the file could be linked
 * to, or the file already existing in the deal. Only the first was ever checked, so a Document
 * Library upload (which has no entity and therefore never produces related transactions) skipped
 * straight to "upload complete" while silently doing nothing.
 */
export const hasFileAssociationWork = (relatedFiles: FindRelatedFilesRes[]): boolean =>
	relatedFiles.some(
		(file) => file.relatedTransactions.length > 0 || file.matchedDocuments.length > 0
	);
